import type { ProcedureSummary } from "./useProceduresQuery";

export type ProcedureLibraryRecord = ProcedureSummary;

export function adaptProcedureSummary(
  procedure: ProcedureSummary,
): ProcedureLibraryRecord {
  return procedure;
}

export function filterProcedureLibrary(
  procedures: ProcedureLibraryRecord[],
  search: string,
  category: string | string[],
  owner: string | string[],
) {
  const categories = Array.isArray(category) ? category : [category];
  const owners = Array.isArray(owner) ? owner : [owner];
  const query = search.trim().toLocaleLowerCase();
  return procedures.filter((procedure) => {
    const matchesSearch =
      !query ||
      procedure.name.toLocaleLowerCase().includes(query) ||
      procedure.id.toLocaleLowerCase().includes(query);
    const matchesCategory =
      categories.length === 0 ||
      categories.includes("all") ||
      splitProcedureCategories(procedure.category).some((value) =>
        categories.includes(value),
      );
    const matchesOwner =
      owners.length === 0 ||
      owners.includes("all") ||
      (procedure.owner !== null && owners.includes(procedure.owner));
    return matchesSearch && matchesCategory && matchesOwner;
  });
}

function splitProcedureCategories(value: string | null): string[] {
  return value
    ? value
        .split(",")
        .map((category) => category.trim())
        .filter(Boolean)
    : [];
}
